export const normalizeLang = (lang) => (lang === "en" ? "en" : "pl");

export const pickLocalized = (lang, dict) => {
  const l = normalizeLang(lang);
  return dict[l] || dict.pl;
};

export const getShopName = (lang) =>
  pickLocalized(lang, {
    pl: "Sklep NIFC",
    en: "NIFC Store",
  });

export const getOrganizationName = (lang) =>
  pickLocalized(lang, {
    pl: "Narodowy Instytut Fryderyka Chopina",
    en: "Fryderyk Chopin Institute",
  });

export const HOMEPAGE_SEO = {
  pl: {
    title: "Sklep cyfrowy Narodowego Instytutu Fryderyka Chopina",
    description:
      "Sklep cyfrowy Narodowego Instytutu Fryderyka Chopina oferuje do zakupu płyty, książki, faksymilia rękopisów Fryderyka Chopina oraz pamiątki po wielkim polskim kompozytorze.",
    twitterImageAlt: "Sklep NIFC - pamiątki i wydawnictwa Fryderyka Chopina",
    localBusinessName: "Sklep stacjonarny - Muzeum Fryderyka Chopina",
    localBusinessDescription:
      "Sklep stacjonarny Narodowego Instytutu Fryderyka Chopina w Muzeum Fryderyka Chopina w Warszawie.",
  },
  en: {
    title: "Digital store of the Fryderyk Chopin Institute",
    description:
      "The digital store of the Fryderyk Chopin Institute offers for purchase records, books, facsimiles of Fryderyk Chopin's manuscripts and memorabilia of the great Polish composer.",
    twitterImageAlt: "NIFC Store - Chopin memorabilia and publications",
    localBusinessName: "Museum shop - Fryderyk Chopin Museum",
    localBusinessDescription:
      "The Fryderyk Chopin Institute museum shop at the Fryderyk Chopin Museum in Warsaw.",
  },
};

export const PRODUCT_PROPERTY_LABELS = {
  material: { pl: "Materiał", en: "Material" },
  color: { pl: "Kolor", en: "Color" },
  capacity: { pl: "Pojemność", en: "Capacity" },
  pages: { pl: "Liczba stron", en: "Number of pages" },
};

export const PERSON_DEFAULT_JOB = {
  pl: "Artysta",
  en: "Artist",
};
